"use client";

import { MdInstallDesktop } from "react-icons/md";
import { LuTerminal } from "react-icons/lu";
import { MdCloudDone } from "react-icons/md";
import { MdMonitor } from "react-icons/md";
import { IconType } from "react-icons";
import Image from "next/image";
import panelDesktop from "@/public/panel-desktop.png";
import panelMobile from "@/public/panel-mobile.png";
export default function PanelShowcase() {

  const cards: { title: string; desc: string; Icon: IconType }[] = [
    {
      title: "1-Click Installs",
      desc: "Easily install mods, plugins, and custom jars with a single click.",
      Icon: MdInstallDesktop,
    },
    {
      title: "Real-time Console",
      desc: "Monitor your server in real-time with our intuitive console interface.",
      Icon: LuTerminal,
    },
    {
      title: "Automated Backups",
      desc: "Never lose your progress with scheduled, off-site daily backups.",
      Icon: MdCloudDone,
    },
    {
      title: "Performance Monitor",
      desc: "Track CPU, RAM, and storage usage with detailed graphs.",
      Icon: MdMonitor,
    },
  ];

  return (
    <section className="relative z-10 w-full bg-black pt-16 sm:pt-24 pb-16 sm:pb-0 px-4 sm:px-8 overflow-hidden">

      <div
        className="absolute top-0 inset-x-0 h-[1px] w-full mask-x-from-50%"
        style={{ backgroundColor: "#6d17b367" }}
      ></div>
      <svg aria-hidden="true" className="pointer-events-none h-full w-full absolute inset-0 opacity-10 fill-black stroke-purple-400/40" style={{ maskImage: "radial-gradient(ellipse 60% 80% at center, white 30%, transparent 70%)" }}>
        <defs>
          <pattern id="faq-grid-top" width="20" height="20" patternUnits="userSpaceOnUse" x="-1" y="-1">
            <path d="M.5 20V.5H20" fill="none" strokeDasharray="0"></path>
          </pattern>
        </defs>
        <rect width="100%" height="100%" strokeWidth="0" fill="url(#faq-grid-top)"></rect>
      </svg>
      <div
        className="pointer-events-none absolute inset-0"
        style={{ backgroundImage: "radial-gradient(ellipse at 40% 0px, #7c44e523 0%, transparent 60%, transparent 100%)" }}
      />
      <div
        className="pointer-events-none absolute top-2/3 left-2/5 h-[400px] w-[1100px] rounded-full opacity-25 blur-3xl"
        style={{ backgroundImage: "radial-gradient(at 0% 0%, #7c44e579, transparent)" }}
      />
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage:
            "radial-gradient(ellipse 70% 50% at 50% 50%, rgba(124,68,229,0.08) 0%, transparent 70%)",
        }}
      />

      <div className="relative max-w-6xl mx-auto flex flex-col gap-8">

        <div className="text-left max-w-xl">
          <h2 className="font-akira text-2xl sm:text-3xl text-white leading-snug">
            Powerful{" "}
            <span
              className="bg-clip-text text-transparent"
              style={{ backgroundImage: "linear-gradient(90deg, #a855f7 0%, #7c3aed 100%)" }}
            >
              Control Panel
            </span>
          </h2>
          <p className="text-gray-500 font-poppins text-sm sm:text-base mt-3 leading-relaxed">
            Manage your server effortlessly with our custom Pterodactyl-based control panel. Designed for both beginners and advanced users.
          </p>
        </div>

        <div className="flex flex-col xl:flex-row gap-10 xl:gap-20 items-start">
          <div className="relative w-full xl:flex-1 flex justify-center pb-0 xl:pb-[180px]">
            <div className="flex xl:hidden justify-center w-full">
              <div
                className="relative"
                style={{
                  width: "220px",
                  borderRadius: "1.5rem",
                  padding: "3px",
                  background: "linear-gradient(145deg, rgba(255,255,255,0.35) 0%, rgba(255,255,255,0.08) 40%, rgba(255,255,255,0.18) 100%)",
                  boxShadow: "0 24px 56px rgba(0,0,0,0.85), 0 2px 8px rgba(0,0,0,0.5)",
                }}
              >
                <div className="absolute pointer-events-none" style={{ left: "-3px", top: "110px" }}>
                  <div style={{ width: "3px", height: "32px", borderRadius: "2px 0 0 2px", background: "linear-gradient(180deg,rgba(255,255,255,0.25),rgba(255,255,255,0.12))", marginBottom: "10px" }} />
                  <div style={{ width: "3px", height: "32px", borderRadius: "2px 0 0 2px", background: "linear-gradient(180deg,rgba(255,255,255,0.25),rgba(255,255,255,0.12))", marginBottom: "10px" }} />
                  <div style={{ width: "3px", height: "32px", borderRadius: "2px 0 0 2px", background: "linear-gradient(180deg,rgba(255,255,255,0.25),rgba(255,255,255,0.12))" }} />
                </div>
                <div className="absolute pointer-events-none" style={{ right: "-3px", top: "135px" }}>
                  <div style={{ width: "3px", height: "56px", borderRadius: "0 2px 2px 0", background: "linear-gradient(180deg,rgba(255,255,255,0.25),rgba(255,255,255,0.12))" }} />
                </div>
                <div className="overflow-hidden" style={{ borderRadius: "1.3rem" }}>
                  <div className="relative flex items-center justify-between px-3" style={{ background: "#080810", height: "28px" }}>
                    <span className="text-white text-[10px] font-semibold font-poppins">9:41</span>
                    <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-black rounded-full" style={{ width: "48px", height: "16px" }} />
                    <div className="flex items-center gap-1">
                      <svg width="9" height="7" viewBox="0 0 9 7" fill="none"><path d="M4.5 5.5a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1z" fill="white" /><path d="M2.5 4C3.1 3.4 3.8 3 4.5 3s1.4.4 2 1" stroke="white" strokeWidth="0.8" strokeLinecap="round" opacity="0.7" /><path d="M1 2.5C2 1.5 3.2 1 4.5 1S7 1.5 8 2.5" stroke="white" strokeWidth="0.8" strokeLinecap="round" opacity="0.45" /></svg>
                      <svg width="12" height="6" viewBox="0 0 12 6" fill="none"><rect x="0.5" y="0.5" width="9" height="5" rx="1.2" stroke="white" strokeOpacity="0.6" strokeWidth="0.8" /><rect x="1.5" y="1.5" width="6" height="3" rx="0.6" fill="white" opacity="0.8" /><path d="M10 2v2" stroke="white" strokeOpacity="0.5" strokeWidth="0.8" strokeLinecap="round" /></svg>
                    </div>
                  </div>
                  <Image src={panelMobile} alt="Mobile panel preview" width={220} height={360} draggable={false} className="w-full block object-cover object-top" style={{ height: "360px" }} />
                </div>
              </div>
            </div>
            <div
              className="relative hidden xl:block w-full rounded-2xl overflow-hidden border border-white/5"
              style={{
                background: "rgba(255,255,255,0.04)",
                backdropFilter: "blur(8px)",
                WebkitBackdropFilter: "blur(8px)",
                boxShadow: "0 24px 64px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.06)",
              }}
            >
              <div className="flex items-center gap-2 px-4 py-3 border-b border-white/5" style={{ background: "rgba(255,255,255,0.03)" }}>
                <span className="w-2.5 h-2.5 rounded-full bg-red-500/70" />
                <span className="w-2.5 h-2.5 rounded-full bg-yellow-500/70" />
                <span className="w-2.5 h-2.5 rounded-full bg-green-500/70" />
                <div className="ml-3 flex-1 h-5 rounded-md flex items-center px-2" style={{ background: "rgba(255,255,255,0.06)" }}>
                  <span className="text-white/30 text-[10px] font-poppins select-none">https://panel.aurex.lk</span>
                </div>
              </div>
              <Image
                src={panelDesktop}
                alt="Control panel preview"
                draggable={false}
                className="w-full block h-auto"
              />
            </div>
            <div className="absolute z-10 hidden xl:block" style={{ bottom: "90px", right: "-30px" }}>
              <div
                className="relative"
                style={{
                  width: "260px",
                  borderRadius: "1.5rem",
                  padding: "3px",
                  background: "linear-gradient(145deg, rgba(255,255,255,0.35) 0%, rgba(255,255,255,0.08) 40%, rgba(255,255,255,0.18) 100%)",
                  boxShadow: "0 24px 56px rgba(0,0,0,0.85), 0 2px 8px rgba(0,0,0,0.5)",
                }}
              >
                <div className="absolute pointer-events-none" style={{ left: "-3px", top: "130px" }}>
                  <div style={{ width: "3px", height: "38px", borderRadius: "2px 0 0 2px", background: "linear-gradient(180deg,rgba(255,255,255,0.25),rgba(255,255,255,0.12))", marginBottom: "12px" }} />
                  <div style={{ width: "3px", height: "38px", borderRadius: "2px 0 0 2px", background: "linear-gradient(180deg,rgba(255,255,255,0.25),rgba(255,255,255,0.12))", marginBottom: "12px" }} />
                  <div style={{ width: "3px", height: "38px", borderRadius: "2px 0 0 2px", background: "linear-gradient(180deg,rgba(255,255,255,0.25),rgba(255,255,255,0.12))" }} />
                </div>
                <div className="absolute pointer-events-none" style={{ right: "-3px", top: "160px" }}>
                  <div style={{ width: "3px", height: "66px", borderRadius: "0 2px 2px 0", background: "linear-gradient(180deg,rgba(255,255,255,0.25),rgba(255,255,255,0.12))" }} />
                </div>
                <div className="overflow-hidden" style={{ borderRadius: "1.3rem" }}>
                  <div className="relative flex items-center justify-between px-3" style={{ background: "#080810", height: "32px" }}>
                    <span className="text-white text-[10px] font-semibold font-poppins">9:41</span>
                    <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-black rounded-full" style={{ width: "54px", height: "18px" }} />
                    <div className="flex items-center gap-1">
                      <svg width="9" height="7" viewBox="0 0 9 7" fill="none"><path d="M4.5 5.5a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1z" fill="white" /><path d="M2.5 4C3.1 3.4 3.8 3 4.5 3s1.4.4 2 1" stroke="white" strokeWidth="0.8" strokeLinecap="round" opacity="0.7" /><path d="M1 2.5C2 1.5 3.2 1 4.5 1S7 1.5 8 2.5" stroke="white" strokeWidth="0.8" strokeLinecap="round" opacity="0.45" /></svg>
                      <svg width="12" height="6" viewBox="0 0 12 6" fill="none"><rect x="0.5" y="0.5" width="9" height="5" rx="1.2" stroke="white" strokeOpacity="0.6" strokeWidth="0.8" /><rect x="1.5" y="1.5" width="6" height="3" rx="0.6" fill="white" opacity="0.8" /><path d="M10 2v2" stroke="white" strokeOpacity="0.5" strokeWidth="0.8" strokeLinecap="round" /></svg>
                    </div>
                  </div>
                  <Image src={panelMobile} alt="Mobile panel preview" width={260} height={420} draggable={false} className="w-full block object-cover object-top" style={{ height: "420px" }} />
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-10 xl:w-72 xl:flex-shrink-0">
            {cards.map(({ title, desc, Icon }) => (
              <div key={title} className="flex items-start gap-5">
                <div
                  className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 mt-0.5"
                  style={{ background: "#7c3aed" }}
                >
                  <Icon className="text-white" size={18} />
                </div>
                <div>
                  <p className="text-white text-sm font-semibold font-poppins mb-1">{title}</p>
                  <p className="text-gray-500 text-xs font-poppins leading-relaxed">{desc}</p>
                </div>
              </div>
            ))}
          </div>

        </div>

      </div>
    </section>
  );
}
